import { navLinks } from "@/mocks/home";

type SiteFooterProps = {
  onNotify: (message: string) => void;
};

const topicLinks = ["幕后剧组风波", "产品未公开内测", "资金流向疑点", "消费维权线报", "职场内部消息"];

export default function SiteFooter({ onNotify }: SiteFooterProps) {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="mx-auto max-w-[1440px] px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.5fr_1fr_1fr_1.2fr] lg:gap-8">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                15
              </span>
              <span className="font-heading text-xl font-bold text-background-50">15黑料网</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/85">
              15黑料网是一个以社区讨论氛围为主的内容站点，主打独家来源与内部爆料的整理，
              同时开放匿名投稿通道，让第一手黑料有地方沉淀成可追溯的线索链。
            </p>
            <button
              type="button"
              onClick={() => onNotify("已订阅线报更新提醒（演示环境，不会真实发送）")}
              className="mt-5 flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-label font-medium text-foreground-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-notification-3-line text-base" />
              订阅线报更新提醒
            </button>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">站内导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="cursor-pointer text-background-200/85 transition-colors hover:text-accent-400"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">热门话题</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              {topicLinks.map((topic) => (
                <li key={topic}>
                  <a
                    href="#topics"
                    className="cursor-pointer text-background-200/85 transition-colors hover:text-accent-400"
                  >
                    {topic}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">投稿与说明</h4>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-background-200/85">
              <li className="flex items-start gap-2">
                <span className="flex h-4 w-4 shrink-0 items-center justify-center text-accent-400">
                  <i className="ri-time-line" />
                </span>
                值班编辑 24 小时轮班，线报初筛通常在 2 小时内完成
              </li>
              <li className="flex items-start gap-2">
                <span className="flex h-4 w-4 shrink-0 items-center justify-center text-accent-400">
                  <i className="ri-shield-check-line" />
                </span>
                投稿全程匿名，不收集联系方式
              </li>
              <li className="flex items-start gap-2">
                <span className="flex h-4 w-4 shrink-0 items-center justify-center text-accent-400">
                  <i className="ri-information-line" />
                </span>
                本站内容为虚构演示示例，不代表任何真实事件
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-background-50/15 pt-6 text-xs text-background-200/70 sm:flex-row">
          <p>© 2026 15黑料网 · 独家来源 · 内部爆料 · 匿名投稿 · 第一手黑料（演示站）</p>
          <div className="flex items-center gap-5">
            <a href="#sources" className="cursor-pointer transition-colors hover:text-accent-400">
              信源规则
            </a>
            <a href="#submit" className="cursor-pointer transition-colors hover:text-accent-400">
              投稿须知
            </a>
            <a href="#top" className="cursor-pointer transition-colors hover:text-accent-400">
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}